import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTrash = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "Capa_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	viewBox: "0 0 172.541 172.541",
	xmlSpace: "preserve",
	...props,
	children: /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", { d: "M166.797,25.078h-13.672h-29.971V0H49.388v25.078H19.417H5.744v15h14.806l10,132.463h111.443l10-132.463h14.805V25.078z  M64.388,15h43.766v10.078H64.388V15z M128.083,157.541H44.46L35.592,40.078h13.796h73.766h13.796L128.083,157.541z" }),
		/* @__PURE__ */ _jsx("rect", {
			x: 80.271,
			y: 65.693,
			width: 12,
			height: 66.232
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 57.271,
			y: 65.693,
			width: 12,
			height: 66.232
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 103.271,
			y: 65.693,
			width: 12,
			height: 66.232
		})
	] })
});
export default SvgTrash;
